import { useEffect } from "react";
import { ApiService } from "./services";
import useLocalStorage from "./useAsyncStorage";

const useSettings = (refresh = false) => {
  const [settings, setSettings] = useLocalStorage("settings", data);

  const getSettings = () => {
    ApiService({ method: "GET", route: "me" }).then((response) => {
      if (response.data.data) {
        setSettings(response.data.data);
      }
    });
  };
  useEffect(() => {
    if (refresh === true) {
      if (
        localStorage.getItem("uhAccessToken") &&
        localStorage.getItem("uhExpiresIn") > 0
      ) {
        getSettings();
      }
    }
  }, []);
  return settings;
};

export default useSettings;

const data = {
  user: {
    wallet: 0,
  },
};
